import React from 'react'
import { useTheme, useMediaQuery } from '@mui/material'
import { Select } from '@center/ui-kit'
import moment from 'moment'
import { 
  DropdownIndicator, 
  ValueContainer, 
  CustomOption, 
  CustomControl, 
  getSelectStyles 
} from 'components/global/Selects/SingleSelectStyles'

export interface YearRangeSelectChoice {
  label: string
  value: number
  id: number
}

interface YearRangeSelectProps {
  value: number
  onChange: (value: YearRangeSelectChoice) => void
}

const YearRangeSelect = ({ value, onChange }: YearRangeSelectProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const currentYear = parseInt(moment().format('y'))
  
  const choices = Array(5).fill(0).map((_, i) => {
    return {
      label: `${currentYear - i}`,
      value: currentYear - i,
      id: i
    }
  })

  return (
    <Select
      value={choices.find((choice) => choice.value === value)}
      onChange={onChange}
      options={choices}
      mainField={'label'}
      components={{ 
        Option: CustomOption,
        DropdownIndicator,
        ValueContainer,
        Control: CustomControl,
        IndicatorSeparator: () => null,
        ClearIndicator: () => null
      }}
      menuPortalTarget={document.body}
      styles={getSelectStyles(theme, isMobile)}
    />
  )
}

export default YearRangeSelect
